/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Origin_Action_PhraseInputs */

const en_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const id_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const ms_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const ca_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const cs_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const da_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const de_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const et_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const es_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const fr_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const hr_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const it_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const lv_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const lt_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const hu_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const nl_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const nb_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const pl_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const pt_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const ro_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const sk_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const sl_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const fi_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const sv_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const vi_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const tr_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const el_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const bg_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const ru_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const sr_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const uk_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const ka_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const hi_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const th_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const ko_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const zh_tw_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

const ja_origin_action_phrase = /** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchase`)
};

/** @type {(inputs: Origin_Action_PhraseInputs) => LocalizedString} */
const zh_origin_action_phrase = en_origin_action_phrase;

/**
* | output |
* | --- |
* | "purchase" |
*
* @param {Origin_Action_PhraseInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const origin_action_phrase = /** @type {((inputs?: Origin_Action_PhraseInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Origin_Action_PhraseInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_origin_action_phrase(inputs)
	if (locale === "ms") return ms_origin_action_phrase(inputs)
	if (locale === "ca") return ca_origin_action_phrase(inputs)
	if (locale === "cs") return cs_origin_action_phrase(inputs)
	if (locale === "da") return da_origin_action_phrase(inputs)
	if (locale === "de") return de_origin_action_phrase(inputs)
	if (locale === "et") return et_origin_action_phrase(inputs)
	if (locale === "es") return es_origin_action_phrase(inputs)
	if (locale === "fr") return fr_origin_action_phrase(inputs)
	if (locale === "hr") return hr_origin_action_phrase(inputs)
	if (locale === "it") return it_origin_action_phrase(inputs)
	if (locale === "lv") return lv_origin_action_phrase(inputs)
	if (locale === "lt") return lt_origin_action_phrase(inputs)
	if (locale === "hu") return hu_origin_action_phrase(inputs)
	if (locale === "nl") return nl_origin_action_phrase(inputs)
	if (locale === "nb") return nb_origin_action_phrase(inputs)
	if (locale === "pl") return pl_origin_action_phrase(inputs)
	if (locale === "pt") return pt_origin_action_phrase(inputs)
	if (locale === "ro") return ro_origin_action_phrase(inputs)
	if (locale === "sk") return sk_origin_action_phrase(inputs)
	if (locale === "sl") return sl_origin_action_phrase(inputs)
	if (locale === "fi") return fi_origin_action_phrase(inputs)
	if (locale === "sv") return sv_origin_action_phrase(inputs)
	if (locale === "vi") return vi_origin_action_phrase(inputs)
	if (locale === "tr") return tr_origin_action_phrase(inputs)
	if (locale === "el") return el_origin_action_phrase(inputs)
	if (locale === "bg") return bg_origin_action_phrase(inputs)
	if (locale === "ru") return ru_origin_action_phrase(inputs)
	if (locale === "sr") return sr_origin_action_phrase(inputs)
	if (locale === "uk") return uk_origin_action_phrase(inputs)
	if (locale === "ka") return ka_origin_action_phrase(inputs)
	if (locale === "hi") return hi_origin_action_phrase(inputs)
	if (locale === "th") return th_origin_action_phrase(inputs)
	if (locale === "ko") return ko_origin_action_phrase(inputs)
	if (locale === "zh") return zh_origin_action_phrase(inputs)
	if (locale === "zh-tw") return zh_tw_origin_action_phrase(inputs)
	if (locale === "ja") return ja_origin_action_phrase(inputs)
	return en_origin_action_phrase(inputs)
});